export const SOCIAL_MEDIA_LOGO = {
  Twitter: require('@src/assets/images/icons/social/twitter.png').default,
  Facebook: require('@src/assets/images/icons/social/facebook.png').default,
  LinkedIn: require('@src/assets/images/icons/social/linkedin.png').default,
  Instagram: require('@src/assets/images/icons/social/instagram.png').default,
  YouTube: require('@src/assets/images/icons/social/youtube.jpg').default
}
